import { Button } from '@calizahq/react-components-v2'
import { FollowMutations } from '@sales-app/graphql/mutations/follow.mutations'
import { FollowUpTask } from '@sales-app/graphql/queries/followup/followUp.queries'
import { FollowUpStatusQueries } from '@sales-app/graphql/queries/followup/follwUpStatus.queries'
import React from 'react'

import { useAlertContext } from '@/context'
import { useMobile } from '@/hooks'
import { useGraphql, useGraphqlMutation } from '@/hooks/useGraphql'

type Props = {
  followUpTask: FollowUpTask
  refetchOnSuccess: () => void
  toggle: () => void
}

export const CompleteFollowUpTask = ({ toggle, followUpTask, refetchOnSuccess }: Props) => {
  const { isTablet } = useMobile()
  const { setAlert } = useAlertContext()

  const { data } = useGraphql<FollowUpStatusQueries.GET.Response>(
    FollowUpStatusQueries.QUERY_KEY,
    FollowUpStatusQueries.getFollowUpTaskStatuses(),
  )

  const completeStatus = data?.followUpTaskStatuses?.find((f) => {
    return f.description.toLowerCase() === 'completed'
  })

  const { mutate, isPending: isMutationLoading } = useGraphqlMutation(FollowMutations.updateFollowUp(), {
    onSuccess: () => {
      refetchOnSuccess && refetchOnSuccess()
      setAlert('Follow-up Task completed.', 'success')
      toggle()
    },
  })

  const handleCompleteFollowUpTask = () => {
    if (completeStatus) {
      mutate({ followUpTask: { followUpTaskIds: [followUpTask.id], followUpTaskStatusId: completeStatus.id } })
    }
  }

  return (
    <div className="flex w-full flex-col flex-wrap px-6 md:max-w-120">
      <h5 className="mb-4 text-header-sm leading-120">I am acknowledging I completed this task.</h5>
      <div className="flex flex-col-reverse justify-between md:flex-row">
        <Button
          className="w-full bg-action-secondary md:flex md:w-auto"
          onClick={toggle}
          size={isTablet ? 'medium' : 'small'}
          variant="secondary"
        >
          Cancel
        </Button>
        <Button
          className="mb-2 w-full bg-text-semantic-success md:mb-0 md:w-auto"
          disabled={isMutationLoading}
          isLoading={isMutationLoading}
          onClick={handleCompleteFollowUpTask}
          size={isTablet ? 'medium' : 'small'}
        >
          Complete
        </Button>
      </div>
    </div>
  )
}
